import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import {
    setIconSource,
    setTranslator,
} from '../actions/ApplicationActions';
import {
    setGlobalSettings,
} from '../actions/FormActions';
import {Instance as CounterPart} from 'counterpart';
/**
 * Lazy loader for the themes we support.
 * @returns {*}
 * @constructor
 */
function ThemeController(props) {

    const {theme, lang, children, setTranslator, setGlobalSettings, setIconSource} = props;

    // Do this one time to setup the translator and css files
    useEffect(() => {

        // Load the CSS File for this theme
        import(`./${theme}/styles.scss`).catch(() => {
            // TODO: Log this to Splunk if it fails for some reason
        });

        // Load the string bundles for this theme
        async function loadLanguageFiles(){
            const translator = new CounterPart();
            translator.setFallbackLocale('en');
            if(lang && theme){
                // Load the babase strings for english
                const baseEn = await import(`./../string-bundles/base/strings.js`);
                translator.registerTranslations('en', baseEn.default);
                // Load the theme's overrides for english
                const stringsEn = await import(`./../string-bundles/${theme}/strings.js`);
                translator.registerTranslations('en', stringsEn.default);

                if(lang !== 'en'){
                    // Load the base language overrides
                    const baseLang = await import(`./../string-bundles/base/strings.${lang}.js`);
                    translator.registerTranslations(lang, baseLang.default);
                    // Load the theme's overrides for the language
                    const stringsLang = await import(`./../string-bundles/${theme}/strings.${lang}.js`);
                    translator.registerTranslations(lang, stringsLang.default);
                }
            }

            translator.setLocale(lang);

            // It might be nice to combine these actions into one (thoughts on that?)
            setTranslator(translator);
            setGlobalSettings(translator.translate('form.global_settings'));
            setIconSource(translator.translate('form.icon.source'));
        }

        loadLanguageFiles().catch(() => {
            // TODO: Log this to Splunk if it fails for some reason
        });
        // eslint-disable-next-line
    }, []);

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        brand: state.app.brand,
        theme: state.app.theme,
        lang: state.app.language,
        translator: state.app.translator,
    };
};

const mapDispatchToProps = dispatch => ({
    setTranslator: (translator) => {
        dispatch(setTranslator(translator));
    },
    setGlobalSettings: (globalSettings) => {
        dispatch(setGlobalSettings(globalSettings));
    },
    setIconSource: (source) => {
        dispatch(setIconSource(source));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeController);
